import React, { useState } from 'react';
import { ApButtonIcon } from '@alixpartners/ui-components';

import {
	Wrapper,
	IconWrapper,
	CollapsedRow,
	Title,
	Description,
	CollapsedColumn,
	CollapsedIconWrapper,
} from './CollapsiblePanel.styles';

export const CollapsiblePanel = ({
	children,
	title,
	align = 'left',
	description,
}) => {
	const [isCollapsed, setCollapsed] = useState(false);

	const handleArrowClick = () => {
		setCollapsed(!isCollapsed);
	};

	return (
		<Wrapper isCollapsed={isCollapsed} align={align}>
			{!isCollapsed && (
				<IconWrapper isCollapsed={isCollapsed} align={align}>
					<ApButtonIcon
						iconName="baseline_keyboard_arrow_right"
						onClick={handleArrowClick}
					/>
				</IconWrapper>
			)}

			{!isCollapsed ? (
				children
			) : (
				<CollapsedRow>
					<CollapsedIconWrapper isCollapsed={isCollapsed} align={align}>
						<ApButtonIcon
							iconName="baseline_keyboard_arrow_right"
							onClick={handleArrowClick}
						/>
					</CollapsedIconWrapper>
					{title && (
						<CollapsedColumn>
							<Title>{title}</Title>
						</CollapsedColumn>
					)}
					{description && (
						<CollapsedColumn>
							<Description>{description}</Description>
						</CollapsedColumn>
					)}
				</CollapsedRow>
			)}
		</Wrapper>
	);
};

export default CollapsiblePanel;
